export default __webpack_public_path__ + "static/white-19b37b52f9657f1a7d6dd3eedbf4a2d5.svg";